import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { fetchTrackerOwner } from '../services/api';

// Dash/case-insensitive, matching the backend's _norm_serial.
const normSerial = (s) => (s || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();

// Samsara tracker serial input for rovers, test boxes and data loggers. While a
// new serial is typed it looks up whether another unit already holds that
// tracker and says which; the server refuses that save as well. The unit's
// saved serial (originalValue) isn't checked, so an existing shared tracker
// doesn't nag on every edit.
function TrackerSerialField({ value, kind, unitId, originalValue, helperText, ...props }) {
  const [owner, setOwner] = useState(null);

  useEffect(() => {
    const key = normSerial(value);
    if (!key || key === normSerial(originalValue)) {
      setOwner(null);
      return undefined;
    }
    let cancelled = false;
    const timer = setTimeout(() => {
      fetchTrackerOwner(value, kind, unitId)
        .then((res) => { if (!cancelled) setOwner(res.owner); })
        .catch(() => { /* the save still checks */ });
    }, 400);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [value, kind, unitId, originalValue]);

  return (
    <TextField
      {...props}
      value={value}
      error={!!owner}
      helperText={owner ? `Already assigned to ${owner.name} (${owner.label})` : helperText}
    />
  );
}

export default TrackerSerialField;
